// Web storage adapter using window.localStorage
export const webLocalStorageAdapter = {
    getItem(key) {
        if (typeof window === 'undefined')
            return null;
        try {
            return window.localStorage.getItem(key);
        }
        catch {
            return null;
        }
    },
    setItem(key, value) {
        if (typeof window === 'undefined')
            return;
        try {
            window.localStorage.setItem(key, value);
        }
        catch {
            // ignore
        }
    },
    removeItem(key) {
        if (typeof window === 'undefined')
            return;
        try {
            window.localStorage.removeItem(key);
        }
        catch {
            // ignore
        }
    },
};
